export const CTA_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'betslip', label: 'Add to Betslip (default)' },
  { value: 'provider-cart', label: 'Sportsbook cart' },
  { value: 'deep-link', label: 'Deep Link' },
  { value: 'url', label: 'URL' },
]

export const CRYPTODOTCOM_CTA_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'betslip', label: 'Default platform action' },
  { value: 'provider-cart', label: 'Crypto.com Cart' },
  { value: 'url', label: 'URL' },
]

export const OG_CTA_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'betslip', label: 'Default platform action' },
  { value: 'provider-cart', label: 'OG Cart' },
  { value: 'url', label: 'URL' },
]
